
import axiosInstance from "../Utils/axiosInterceptor";
import {OrderItem} from "../models/OrderItem";
import {Cart} from "../models/Cart";
import {User} from "../models/User";
import {PaystackPayment} from "../models/PaystackPayment";


export class OrderService {

    static async readCartByUser() {
        try {
            const response = await axiosInstance.get<OrderItem[]>("/read_cart_by_user/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async readCartCountByUser() {
        try {
            const response = await axiosInstance.get<Cart>("/read_cart_count_by_user/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async addToCart(data: OrderItem) {
        try {
            const response = await axiosInstance.post<OrderItem>("/add_to_cart/", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    static async removeOrderItemById(id: number) {
        try {
            const response = await axiosInstance.delete("/remove_order_item_by_id/"+id+"/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    static async getOrderRestaurantsByUser() {
        try {
            const response = await axiosInstance.get("/get_order_restaurants_by_user/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getOrdersByUser() {
        try {
            const response = await axiosInstance.get("/read_orders_by_user/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async confirmOrder(driver: User | null) {
        try {
            const response = await axiosInstance.post("/confirm_order/", driver);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async readCartByUserId(user_id: string | number | undefined) {
        try {
            const response = await axiosInstance.get<OrderItem[]>("/read_cart_by_user_id/"+user_id);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getActiveOrdersByDriver() {
        try {
            const response = await axiosInstance.get<OrderItem[]>("/get_active_orders_by_driver/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getActiveOrdersByUser() {
        try {
            const response = await axiosInstance.get<OrderItem[]>("/get_active_orders_by_user/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getAllOrdersByDriver() {
        try {
            const response = await axiosInstance.get<OrderItem[]>("/get_all_orders_by_driver/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async completeCodeByDeliveryCode(code: number) {
        try {
            const response = await axiosInstance.post("/complete_code_by_delivery_code/", { code });
            return response; // ← return full response, not response.data
        } catch (error) {
            throw error;
        }
    }

    static async getLastOrdersByUser() {
        try {
            const response = await axiosInstance.get<OrderItem[]>("/get_last_orders_by_user/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async checkRating() {
        try {
            const response = await axiosInstance.get("/check_rating/");
            return response;
        } catch (error: any) {
            if (error.response?.status === 303) {
                return error.response;  // return it so the caller can handle it
            }
            throw error;
        }
    }

    static async rateOrder(data:any) {
        try {
            const response = await axiosInstance.post("/rate_order/", data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getOrderDistance(): Promise<{ distance_km: number, blocks: number }> {
        const response = await axiosInstance.get('/get_order_distance/');
        return response.data;
    }

    static async setOrderType(driver: User | null) {
        try {
            const response = await axiosInstance.post('set_order_type/', { id: driver?.id ?? null });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getAvailableDrivers(latitude: number, longitude: number) {
        try {
            const response = await axiosInstance.get<User[]>(`/get_available_drivers/${latitude}/${longitude}/`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async updateOrderItemQuantityByOrderItemId(id: number, quantity: number) {
        try {
            const response = await axiosInstance.put<OrderItem>(`/update_order_item_quantity_by_order_item_id/${id}/${quantity}/`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async cancelAndRefund(paystackPayment: PaystackPayment) {
        try {
            const response = await axiosInstance.post(`/cancel_and_refund/`, paystackPayment);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}